export default function Nav() {
    return `
        <nav>
            <button class="toggle__nav toggle__JACKS0N__nav --secondary --big menuButton" 
                    aria-expanded="false" 
                    aria-haspopup="true"
                    aria-controls="menuOptions" 
                    aria-labelledby="button-label" 
                    data-roll="button"
                    
                >
                <span class="__button-label">Jackson Greenberg</span>
                <abbr class="toggleIcon" title="">
                    <svg viewBox="0 0 24 24" fill="none" >
                        <path d="M10 7L15 12L10 17" stroke="currentColor" stroke-width="0.875" />
                        <path d="M14 7L19 12L14 17" stroke="currentColor" stroke-width="0.875" />
                    </svg>
                </abbr>
            </button>

             
        </nav>
       

    `;
} 